// extracted by mini-css-extract-plugin
export var brand = "_18-9";
export var button = "_18-0";
export var chevron = "_18-v";
export var chevronButton = "_18-w";
export var content = "_18-n";
export var danger = "_18-g";
export var dangerOutlined = "_18-h";
export var dark = "_18-l";
export var darkTheme = "_18-c";
export var extraSmall = "_18-4";
export var fullWidth = "_18-8";
export var ghost = "_18-d";
export var gray = "_18-t";
export var icon = "_18-p";
export var iconButton = "_18-s";
export var iconButtonBorder = "_18-x";
export var iconButtonBorderDark = "_18-y";
export var iconButtonBorderLight = "_18-z";
export var iconLeft = "_18-q";
export var iconRight = "_18-r";
export var large = "_18-1";
export var light = "_18-m";
export var medium = "_18-2";
export var micro = "_18-5";
export var nano = "_18-7";
export var outlined = "_18-k";
export var pending = "_18-a";
export var primary = "_18-i";
export var shadow = "_18-o";
export var small = "_18-3";
export var solidLight = "_18-e";
export var solidLightBrand = "_18-f";
export var spinner = "_18-u";
export var transparent = "_18-j";
export var warning = "_18-b";
export var wideNano = "_18-6";